<script setup lang="ts">
import { useTranslation } from "@/composables"

defineProps({
  pageMessage: {
    type: String,
    default: "",
  },
})

const { t } = useTranslation()
</script>

<template>
  <div class="gpx-main-gallery-hidden-message">
    <h4>{{ t("main_gallery_hidden_message.title") }}</h4>
    <p>{{ pageMessage }}</p>
  </div>
</template>

<style scoped>
.gpx-main-gallery-hidden-message {
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 2rem;
}

.gpx-main-gallery-hidden-message h4,
.gpx-main-gallery-hidden-message p {
  padding: 0;
  margin: 0;
}

@media (width >= 768px) {
  .gpx-main-gallery-hidden-message {
    min-height: 75vh;
  }
}
</style>
